import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {TableHeightService} from "../../services/table-height.service";
import {Subscription} from "rxjs";
import {ModalService} from "../../services/modal.service";
import {NotificationService} from "../../services/notification.service";
import {ReturnDataService} from "./services/return-data.service";
import {FilterModelDto} from "../../models/filter.model";
import {ReturnPaymentDto} from "./models/return.models";
import {SortTableService} from "../../services/sort-table.service";
import {SortDataColumn} from "../../models/table.model";
import {ReturnDetailService} from "./services/return-detail.service";

@Component({
  selector: 'app-return-list',
  templateUrl: './return-list.component.html',
  styleUrls: ['./return-list.component.scss']
})
export class ReturnListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('tableBlock') tableBlock: ElementRef | undefined
  @ViewChild('tableBody') tableBody: ElementRef | undefined
  @ViewChild('paymentBlock') returnBlock: ElementRef | undefined

  delta = 150
  lastPage!: boolean
  currentPage = 0

  isOpenFilter = false

  isOpenReturnDetail = false

  returnList: ReturnPaymentDto[] = []

  subs: Subscription[] = []

  filterAdditional: FilterModelDto[] | undefined
  filterCurrencies: FilterModelDto[] | undefined
  filterBanks: FilterModelDto[] | undefined

  sortColumnData: SortDataColumn | undefined


  constructor(
    private tableHeightService: TableHeightService,
    private renderer: Renderer2,
    private modalService: ModalService,
    private notificationService: NotificationService,
    private returnDataService: ReturnDataService,
    private sortTableService: SortTableService,
    private returnDetailService: ReturnDetailService
  ) {
  }


  ngOnInit() {
    this.initFilter()
    this.initModal()
    this.getReturnList()
  }

  ngAfterViewInit() {
    this.subs.push(this.tableHeightService.tableHeight$.subscribe({
      next: (res) => {
        this.renderer.setStyle(this.tableBlock?.nativeElement, 'height', res)
      },
    }))
  }

  ngOnDestroy() {
    this.subs.forEach(item => item.unsubscribe())
  }

  getReturnList() {
    this.lastPage = true
    this.returnDataService.loadReturnList(this.currentPage).subscribe({
      next: (res) => {
        this.returnList.push(...res.content)
        this.currentPage++
        this.lastPage = res.last
      }
    })
  }

  initFilter() {
    this.subs.push(this.returnDataService.loadReturnFilter().subscribe({
      next: (res) => {
        this.filterAdditional = res['additional_params']
        this.filterCurrencies = res['currencies']
        this.filterBanks = res['banks']
      }
    }))
  }

  initModal() {
    this.subs.push(this.modalService.isModalOpen$.subscribe({
      next: (res) => {
        if (!res) {
          this.isOpenReturnDetail = false
        }
      }
    }))
  }


  toggleFilter(filterState: boolean) {
    this.isOpenFilter = filterState
  }

  upload() {

  }

  onScroll(event: any): void {
    const tableBodyHeight = this.tableBody?.nativeElement.clientHeight
    const tableBlockHeight = this.tableBlock?.nativeElement.clientHeight
    const scrollTable = event.target.scrollTop
    if (tableBodyHeight - tableBlockHeight - scrollTable < this.delta && !this.lastPage) {
      this.getReturnList()
    }
  }

  copyDetail() {
    this.modalService.closeModal()
    this.notificationService.showNotification()
    this.returnDetailService.returnDetailService$.next(null)
  }

  openReturnDetail(type: string, id: number) {
    if (type === 'dblclick') {
      this.getDetailReturnPayment(id)
      return
    }

    if (type === 'click' && window.innerWidth <= 768) {
      this.getDetailReturnPayment(id)
    }
  }

  getDetailReturnPayment(id: number) {
    this.returnDataService.loadDetailReturn(id).subscribe({
      next: (res) => {
        this.returnDetailService.returnDetailService$.next(res)
        this.isOpenReturnDetail = true
      }
    })
  }

  sortColumn(column: string) {
    this.sortColumnData = this.sortTableService.sort(column)
  }

}
